module.exports = __webpack_public_path__ + "img/92.e2da3089.jpg";